module.exports = __webpack_public_path__ + "img/ml3053.e64d425c.png";